/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { Gender } from './Gender';
import {
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
    GenderToJSONTyped,
} from './Gender';
import type { GetLocationResponse } from './GetLocationResponse';
import {
    GetLocationResponseFromJSON,
    GetLocationResponseFromJSONTyped,
    GetLocationResponseToJSON,
    GetLocationResponseToJSONTyped,
} from './GetLocationResponse';
import type { GuardType } from './GuardType';
import {
    GuardTypeFromJSON,
    GuardTypeFromJSONTyped,
    GuardTypeToJSON,
    GuardTypeToJSONTyped,
} from './GuardType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetStudentResponse
 */
export interface GetStudentResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetStudentResponse
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    preferredName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetStudentResponse
     */
    dateOfBirth: Date;
    /**
     * 
     * @type {Gender}
     * @memberof GetStudentResponse
     */
    gender: Gender;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    medications: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    allergies: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    specialNeeds: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    primaryDoctor: string | null;
    /**
     * 
     * @type {GuardType}
     * @memberof GetStudentResponse
     */
    guardType: GuardType;
    /**
     * 
     * @type {any}
     * @memberof GetStudentResponse
     */
    startDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetStudentResponse
     */
    dropDate: any | null;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    cellPhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    homePhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    fullAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStudentResponse
     */
    addressLine3: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetStudentResponse
     */
    sendSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetStudentResponse
     */
    postPublicly: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetStudentResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetStudentResponse
     */
    guardianUserId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetStudentResponse
     */
    discountPercentage: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {Array<GetLocationResponse>}
     * @memberof GetStudentResponse
     */
    locations: Array<GetLocationResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof GetStudentResponse
     */
    noCharge: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetStudentResponse
     */
    tuition: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetStudentResponse
     */
    totalBalance: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetStudentResponse
     */
    recital: boolean | null;
}



/**
 * Check if a given object implements the GetStudentResponse interface.
 */
export function instanceOfGetStudentResponse(value: object): value is GetStudentResponse {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('preferredName' in value) || value['preferredName'] === undefined) return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('medications' in value) || value['medications'] === undefined) return false;
    if (!('allergies' in value) || value['allergies'] === undefined) return false;
    if (!('specialNeeds' in value) || value['specialNeeds'] === undefined) return false;
    if (!('primaryDoctor' in value) || value['primaryDoctor'] === undefined) return false;
    if (!('guardType' in value) || value['guardType'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('dropDate' in value) || value['dropDate'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    if (!('homePhone' in value) || value['homePhone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('fullAddress' in value) || value['fullAddress'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('sendSms' in value) || value['sendSms'] === undefined) return false;
    if (!('postPublicly' in value) || value['postPublicly'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('guardianUserId' in value) || value['guardianUserId'] === undefined) return false;
    if (!('discountPercentage' in value) || value['discountPercentage'] === undefined) return false;
    if (!('locations' in value) || value['locations'] === undefined) return false;
    if (!('noCharge' in value) || value['noCharge'] === undefined) return false;
    if (!('tuition' in value) || value['tuition'] === undefined) return false;
    if (!('totalBalance' in value) || value['totalBalance'] === undefined) return false;
    if (!('recital' in value) || value['recital'] === undefined) return false;
    return true;
}

export function GetStudentResponseFromJSON(json: any): GetStudentResponse {
    return GetStudentResponseFromJSONTyped(json, false);
}

export function GetStudentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStudentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'preferredName': json['preferredName'],
        'dateOfBirth': (new Date(json['dateOfBirth'])),
        'gender': GenderFromJSON(json['gender']),
        'medications': json['medications'],
        'allergies': json['allergies'],
        'specialNeeds': json['specialNeeds'],
        'primaryDoctor': json['primaryDoctor'],
        'guardType': GuardTypeFromJSON(json['guardType']),
        'startDate': json['startDate'],
        'dropDate': json['dropDate'],
        'cellPhone': json['cellPhone'],
        'homePhone': json['homePhone'],
        'email': json['email'],
        'fullAddress': json['fullAddress'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'sendSms': json['sendSms'],
        'postPublicly': json['postPublicly'],
        'isActive': json['isActive'],
        'guardianUserId': ActorActivityRecordActorUserIdFromJSON(json['guardianUserId']),
        'discountPercentage': BalanceUnitStatementEntryDebitFromJSON(json['discountPercentage']),
        'locations': ((json['locations'] as Array<any>).map(GetLocationResponseFromJSON)),
        'noCharge': json['noCharge'],
        'tuition': BalanceUnitStatementEntryDebitFromJSON(json['tuition']),
        'totalBalance': BalanceUnitStatementEntryDebitFromJSON(json['totalBalance']),
        'recital': json['recital'],
    };
}

export function GetStudentResponseToJSON(json: any): GetStudentResponse {
    return GetStudentResponseToJSONTyped(json, false);
}

export function GetStudentResponseToJSONTyped(value?: GetStudentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'preferredName': value['preferredName'],
        'dateOfBirth': value['dateOfBirth'].toISOString().substring(0,10),
        'gender': GenderToJSON(value['gender']),
        'medications': value['medications'],
        'allergies': value['allergies'],
        'specialNeeds': value['specialNeeds'],
        'primaryDoctor': value['primaryDoctor'],
        'guardType': GuardTypeToJSON(value['guardType']),
        'startDate': value['startDate'],
        'dropDate': value['dropDate'],
        'cellPhone': value['cellPhone'],
        'homePhone': value['homePhone'],
        'email': value['email'],
        'fullAddress': value['fullAddress'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'sendSms': value['sendSms'],
        'postPublicly': value['postPublicly'],
        'isActive': value['isActive'],
        'guardianUserId': ActorActivityRecordActorUserIdToJSON(value['guardianUserId']),
        'discountPercentage': BalanceUnitStatementEntryDebitToJSON(value['discountPercentage']),
        'locations': ((value['locations'] as Array<any>).map(GetLocationResponseToJSON)),
        'noCharge': value['noCharge'],
        'tuition': BalanceUnitStatementEntryDebitToJSON(value['tuition']),
        'totalBalance': BalanceUnitStatementEntryDebitToJSON(value['totalBalance']),
        'recital': value['recital'],
    };
}

